// src/components/useTables.js
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

export function useTables(API_URL) {
  const [tables, setTables] = useState([]);

  const fetchTables = async () => {
    try {
      const res = await fetch(`${API_URL}/getTablesDB`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      if (!res.ok) throw new Error("Errore durante il recupero delle tabelle");
      const data = await res.json();
      setTables(data);
    } catch (err) {
      console.error(err);
      toast.error("Errore durante il caricamento delle tabelle");
    }
  };

  useEffect(() => {
    fetchTables();
  }, [API_URL]);

  return { tables, fetchTables };
}
